import React              from 'react'
import TeamCompareHeader  from './statistics/TeamCompareHeader'
import VisPercent         from './statistics/VisPercent'
import VisIcons           from './statistics/VisIcons'
import VisCircle          from './statistics/VisCircle'
import StatsTable         from './statistics/StatsTable'

const MatchStatsCol = ({
  home      = {},
  away      = {},
  stats     = [],
  split     = false,
  colLen    = 2,
  colNo     = 0
}) => {

  const iStatsLen     = stats.length
  let aData       = []
  let aClassNames = [ 'content' ]
  
  for ( let i = 0; i < iStatsLen; i++ ) {
    const oStats  = stats[i]
    
    if ( i===0 ) {
      let extra = {}
      extra['bordered'] = true
      if ( (oStats.type === 'dataVis' || oStats.type === 'dataVisIcons' || oStats.type === 'dataVisPie' || oStats.type === 'dataVisCount') && oStats.data.text ) {
        extra['heading'] = oStats.data.text || ''
        extra['bordered'] = false
      }
      
      aData.push(
        <TeamCompareHeader key={'tc'+i} home={home} away={away} {...extra} />
      )
    
    }
    
    if ( oStats.type === 'table' ) {
      aData.push(
        <StatsTable key={'st'+i} stats={oStats.data} />
      )
    } else if ( oStats.type === 'dataVis' || oStats.type === 'dataVisIcons' || oStats.type === 'dataVisCount' ) {
      if ( i !== 0 ) {
        aData.push(
          <TeamCompareHeader key={'tc'+i} noTeams={true} heading={ oStats.data.text || '' } />
        )
      }
      if ( oStats.type === 'dataVisIcons' ) {
        aData.push(
          <VisIcons key={'dvi'+i} homeColor={home.color} awayColor={away.color} {...oStats.data} /> 
        )
      } else if ( oStats.type === 'dataVisCount' ) {
        aData.push(
          <VisIcons key={'dvi'+i} type="count" homeColor={home.color} awayColor={away.color} {...oStats.data} />  
        )
      } else {
        aData.push(
          <VisPercent key={'dv1'+i} large={ oStats.size === 'large' ? true : false } homeColor={home.color} awayColor={away.color} {...oStats.data} />  
        )
      }
    } else if ( oStats.type === 'dataVisPie' ) {
      aData.push(
        <div className="chart-container parallel" key={'dvph'+i}>
          <VisCircle color={home.color} won={oStats.data.homeWon} total={oStats.data.homeTotal} />
        </div>
      )
      
      aData.push(
        <div className="chart-container parallel" key={'dvpa'+i}>
          <VisCircle color={away.color} won={oStats.data.awayWon} total={oStats.data.awayTotal} />
        </div>
      )
    }
  }
  
  let hackWidth = {
    style : { overflow: 'auto' }
  }
  if ( split !== true && colLen > 1 ) {
    if ( colNo === 0 ) {
      aClassNames.push('col-a')
    }else{
      aClassNames.push('col-b')
    }
    hackWidth.style = { marginRight: 0 } /* remove when they fix */
  }
  
  return (
    <div className={ aClassNames.join(' ') } {...hackWidth} >
      {aData}
    </div>
  )
  
}

const MatchEvents = ({
  title   = '',
  col     = [],
  split   = false,
  home    = {},
  away    = {}
}) => {
        
  /* itterate columns */
  let aTitle      = title
  
  if ( aTitle.constructor !== Array ) {
    aTitle = [ aTitle ]
  }
  const iColLen     = col.length
  
  /* No data so show nothing */
  if ( iColLen == 0 ) {
    return (
      <div />
    )
  }
  
  let aCols     = []
  
  for ( let i = 0; i < iColLen; i++ ) {
    const aStats  = col[i]
    aCols.push(
      <MatchStatsCol key={i} split={split} home={home} away={away} stats={aStats} colNo={i} colLen={iColLen} />
    )
  }
  
  if ( split === true ) {
    return (
      <div className="sub-module-split">      
        <div className="module-split">
          <article className="sub-module equal-height countChartList height-reset">
            {
              aTitle[0] && <header className="bordered"><h1>{aTitle[0]}</h1></header> || null
            }
            {aCols[0]}
          </article>
        </div>
        <div className="module-split">
          <article className="sub-module equal-height countChartList height-reset">
            {
              aTitle[1] && <header className="bordered"><h1>{aTitle[1]}</h1></header> || null
            }
            {aCols[1]}
          </article>
        </div>
      </div>
    )
  } else {
    return (
      <article className="sub-module" style={ { overflow: 'auto' } }>
        {
          aTitle[0] && <header className="bordered"><h1>{aTitle[0]}</h1></header> || null
        }
        <div className="stacked-rl">
          {aCols}
        </div>
      </article>
    )
  }
}

export default MatchEvents



// WEBPACK FOOTER //
// ../app/components/gamepackage/rugby/components/MatchEvents.jsx